import {
  Button,
  ButtonGroup,
  Form,
  FormButton,
  FormSubmitHandler,
  FormField,
} from 'platform/components';
import {VStack} from 'platform/foundation';

import {usePutServiceItemSetDiscountMutation} from '@dms/api/workshop';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {bulkDiscountFormSchema, BulkDiscountFormType} from '../types/bulkDiscountFormSchema';

interface BulkDiscountFormProps extends RequiredTestIdProps {
  serviceCaseId: string;
  serviceOrderId: string;
  items: {serviceJobId: string; serviceItemId: string}[];
  onSubmit: VoidFunction;
  onClose: VoidFunction;
}

export function BulkDiscountForm(props: BulkDiscountFormProps) {
  const [putServiceOrderItemsAssignMechanic] = usePutServiceItemSetDiscountMutation();

  const handleSubmit: FormSubmitHandler<BulkDiscountFormType> = async (data) => {
    await putServiceOrderItemsAssignMechanic({
      serviceCaseId: props.serviceCaseId,
      serviceOrderId: props.serviceOrderId,
      body: {
        items: props.items.map((item) => ({
          serviceItemId: item.serviceItemId,
          serviceJobId: item.serviceJobId,
        })),
        discountRatio: data.discountRatio / 100,
      },
    })
      .unwrap()
      .then(() => {
        props.onSubmit();
        props.onClose();
      })
      .catch(handleApiError);
  };

  return (
    <Form<BulkDiscountFormType>
      experimentalZodSchema={bulkDiscountFormSchema}
      onSubmit={handleSubmit}
    >
      {(control) => (
        <VStack spacing={4}>
          <FormField
            control={control}
            label={i18n.t('general.labels.discount')}
            name="discountRatio"
            type="number"
            isRequired
            suffix="%"
            data-testid={suffixTestId('discount', props)}
          />
          <ButtonGroup align="right">
            <Button
              title={i18n.t('general.actions.discard')}
              variant="secondary"
              onClick={props.onClose}
              data-testid={suffixTestId('discardButton', props)}
            />
            <FormButton
              control={control}
              type="submit"
              title={i18n.t('general.actions.save')}
              data-testid={suffixTestId('saveButton', props)}
            />
          </ButtonGroup>
        </VStack>
      )}
    </Form>
  );
}
